export default function MapOverlayList({ children }) {
  return (
    <div className="w-44 xl:w-80 h-full overflow-x-hidden overflow-y-auto xl:pr-3 flex flex-col">
      {children}
    </div>
  );
}
